import { DateTime } from "@easepick/bundle";
import modelBaseV2 from "../model-base-v2.model";

/**
 * Monitoring Report File Content Model
 * 
 * 
 * 
 * @author cmc.nttruong1
 */


const FileContentModel = {
  getListIntfEdiCustomers: () => {
    return modelBaseV2.get('/api/intf-edi/customers');
  },

  getListIntfEdiFileType: () => {
    return modelBaseV2.get('/api/intf-edi/GetIntfFileType');
  },

  searchContentReport: (body) => {
    return modelBaseV2.post('/api/intf-edi/IntfFileContentReport', { body });
  },

  exportSummaryData: (body) => {
    const fileName = `Monitoring_Report_Summary_Data_${DateTime.now()}`;
    return modelBaseV2.postDownload('/api/intf-edi/IntfFileContentSummary', { body }, fileName);
  },

  exportRawData: (body) => {
    const fileName = `Monitoring_Report_Raw_Data_${DateTime.now()}`;
    return modelBaseV2.postDownload('/api/intf-edi/IntfFileContentRawData', { body }, fileName);
  },

  exportSaleDateVsImei: (body) => {
    const fileName = `Monitoring_Report_Sales_Date_vs_IMEI_${DateTime.now()}`;
    return modelBaseV2.postDownload('/api/intf-edi/IntfFileContentSalesDateVsIMEI', { body }, fileName);
  },
}

export default FileContentModel;
